import { netsparkAxios } from 'core/services/HTTPService';
import { getRequestStatusUrl } from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { IChartItem } from 'core/models/Recharts.models';

const getRequestStatus = (signal: AbortSignal, params: TPeriod) => netsparkAxios
  .get<IChartItem[]>(getRequestStatusUrl, { signal, params });

export default getRequestStatus;
